// extracted by mini-css-extract-plugin
export default {"btnCaret":"styles_btnCaret__fsa7k","noRequestsBadge":"styles_noRequestsBadge__v8sJD","btnVehicleInfo":"styles_btnVehicleInfo__FPml-","btnWhatsapp":"styles_btnWhatsapp__GnLH8"};